import { render, staticRenderFns } from "./RegistrationBody.vue?vue&type=template&id=81f6879a&scoped=true&"
import script from "./RegistrationBody.vue?vue&type=script&lang=js&"
export * from "./RegistrationBody.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationBody.vue?vue&type=style&index=0&id=81f6879a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f6879a",
  null
  
)

export default component.exports